<template>

  <div>

    <el-card>

      <div slot="header" style="text-align: center">
        <span style="font-size: 18px;font-weight: bold;">本站使用技术</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">
          <div>

            <div class="div-info">
              <el-row>
                <el-col :span="9">后端：</el-col>
                <el-col :span="15">Golang</el-col>
              </el-row>
            </div>

            <div class="div-info">
              <el-row>
                <el-col :span="9">数据库：</el-col>
                <el-col :span="15">MongoDB</el-col>
              </el-row>
            </div>

            <div class="div-info">
              <el-row>
                <el-col :span="9">前端：</el-col>
                <el-col :span="15">Vue.js + Element</el-col>
              </el-row>
            </div>

            <div class="div-info">
              <el-row>
                <el-col :span="9">移动端：</el-col>
                <el-col :span="15">Flutter</el-col>
              </el-row>
            </div>

            <div class="div-info">
              <el-row>
                <el-col :span="9">前端服务器：</el-col>
                <el-col :span="15">阿里云</el-col>
              </el-row>
            </div>

            <div class="div-info">
              <el-row>
                <el-col :span="9">后端服务器：</el-col>
                <el-col :span="15">Gen10 Plus</el-col>
              </el-row>
            </div>

          </div>
        </el-col>

        <el-col :span="12">

          <div class='sc-list'>
            <div class="sc-item" v-for="(image,index) in images" :key="index">
              <el-image style="width: 100%;height: 100%" :src="image" fit="cover"></el-image>
            </div>
          </div>

        </el-col>
      </el-row>

    </el-card>

  </div>

</template>

<script>

export default {
  name: 'Station',
  data () {
    return {
      images: [
        require('@/assets/images/about/golang.jpeg'),
        require('@/assets/images/about/mongodb.jpg'),
        require('@/assets/images/about/vue.jpeg'),
        require('@/assets/images/about/flutter.jpeg')
      ]
    }
  }
}
</script>

<style scoped>
.sc-item{
  margin: 0 30px 30px;
  width: 120px;
  height: 120px;
}
.sc-list{
  flex-wrap: wrap;
  display: flex;
  width: 360px;
  float: right;
}

.div-info{
  line-height: 1.5;
  margin-bottom: 20px;
  font-size: 18px;
  letter-spacing: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/about/Station.vue